import React from 'react';
import ReactPaginate from 'react-paginate';

/* Utilities */
import { trans } from 'js/utilities';

export default function VehicleOverviewPagination({ totalPages, page, updatePage, isDesktop }) {
    if (totalPages <= 1) return null;

    return (
        <nav
            aria-label="navigation"
            role="navigation"
            className="mt-6 mt-xl-8"
        >
            <ReactPaginate
                previousLabel={trans(`sulu.content_block.vehicle_overview.pagination.previous`, {}, '')}
                previousClassName="page-item page-item--prev"
                previousLinkClassName="page-link"
                nextLabel={trans(`sulu.content_block.vehicle_overview.pagination.next`, {}, '')}
                nextClassName="page-item page-item--next"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                activeClassName="active"
                disabledClassName="disabled"
                pageCount={totalPages}
                marginPagesDisplayed={isDesktop ? 2 : 1}
                pageRangeDisplayed={3}
                forcePage={page - 1}
                onPageChange={(page) => {
                    updatePage(page.selected + 1);
                }}
                hrefBuilder={(page) => {
                    const searchParams = new URLSearchParams(location.search);
                    searchParams.set('page', page);

                    return `?${searchParams.toString()}`;
                }}
            />
        </nav>
    );
}
